import StatusTableDto from 'app/admin/status/dto/StatusTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class StatusTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'statusControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<StatusTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, StatusTableDto)))
				.catch(reject);
		});
	}
}

export default new StatusTableService();
